/***
 * Messages Status Constants
 * */

export const SUCCESS_MSG_TYPE = 'success';
export const WARNING_MSG_TYPE = 'warning';
export const ERROR_MSG_TYPE = 'error';
export const INFO_MSG_TYPE = 'info';
export const SUCCESS_MESSAGE = 'success';

export const AUTH_TOKEN = 'token';

export const INVERTER_TYPE_SUNGROW = 'SUNGROW-SGxKTL';
export const INVERTER_TYPE_ABB = 'ABB-TRIO-50.0/60.0-TL-OUTD';